import {Injectable} from '@angular/core';
import {Subject, Observable} from 'rxjs';
import {BehaviorSubject} from 'rxjs/Rx';
import {filter} from 'rxjs/operators';

@Injectable()
export class TreatmentSelectionService {
  private _selectionSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  public selection: Observable<any> = this._selectionSubject.pipe(filter(subject => !!subject));

  private spinner$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public isSpinnerActive$: Observable<boolean> = this.spinner$.asObservable();

  public therapiesAndTrailCalculatedHeight$: BehaviorSubject<string> = new BehaviorSubject('100%');
  public therapiesAndTrailCalculatedDetailsHeight$: BehaviorSubject<string> = new BehaviorSubject('100%');


  public updateSelection(subject) {
    this._selectionSubject.next(subject);
  }

  public getSelectionSubjectValue(): any {
    return this._selectionSubject.getValue();
  }

  public setSpinnerActive(active: boolean) {
    this.spinner$.next(active);
  }
}
